import styled from '@emotion/styled'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'

export const EvaluationBanner = styled.div`
  &&& {
    margin: 12px 0 8px 0;
    font-weight: bold;
    line-height: 18px;
    font-size: 14px;
    width: ${DEFAULT_DRAWER_WIDTH}px;
    display: flex;
    align-items: center;
  }
`
